import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";
import { IResponse } from "../interfaces/response";

export type TBusinessType = {
  id: number;
  name: string;
};

const getBusinessTypes = async (): Promise<IResponse<TBusinessType[]>> => {
  const { data } = await getData(ajaxEndpoints.DB_GET_BUSINESS_TYPES);
  return data;
};

export function useBusinessTypes() {
  return useQuery<IResponse<TBusinessType[]>>(
    ["getBusinessTypes"],
    getBusinessTypes,
    {
      refetchOnWindowFocus: false,
      staleTime: 300000, // Cache for 5 minutes
    }
  );
}
